// extracted by mini-css-extract-plugin
export default {"title_box":"TeachModeComponent_title_box__Os9Jo","img_box":"TeachModeComponent_img_box__nAYLb"};